import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import {
  H3,
  VerticalSpacer,
  SearchInputField,
  HorizontalSpacer,
  FovModal,
  HubSpotForm,
  RefreshOutlined,
  FovSelect,
  FovOption,
} from 'components';
import { decode } from 'utils';
import { HeaderArea, ActionArea, CreatorList, Title, CTA, Search, RefreshFiles, TeamListContainer } from './styles';
import { ViewOptions } from './ViewOptions';
import { paramsFromURL, paramsToObject } from 'utils/paramHelpers';
import { withTheme } from 'styled-components';
import { ModelContext } from './ModelContext';
import { setSelectedUserTeam } from 'store/actions/userData';

const ModelsHeader = withTheme(props => {
  const { theme } = props;
  const { getModels, pageTitle, getTeamData } = useContext(ModelContext);
  const searchFieldRef = useRef('');
  const dispatch = useDispatch();
  const userDataStore = useSelector(state => state.userData);

  const [ searchParams, setSearchParams ] = useSearchParams();
  const params = paramsToObject(decode(paramsFromURL()));
  const userTeams = useMemo(() => userDataStore.data?.teams, [ userDataStore.data?.teams ]);
  const selectedTeamId = useMemo(() => userDataStore.selectedTeamId, [ userDataStore.selectedTeamId ]);
  const selectedTheme = userDataStore.userPreferences.theme;
  const modelsLoading = userDataStore.modelsLoading;

  const [ showModal, setShowModal ] = useState(false);
  const onTeamModels = location.pathname.includes('/team-models');

  useEffect(() => {
    if (!params.search) {
      searchFieldRef.current.value = '';
    }
  }, [ params.search ]);

  useEffect(() => {
    if (Array.isArray(userTeams) && userTeams.length > 0 && !selectedTeamId) {
      dispatch(setSelectedUserTeam(userTeams[0].teamId));
    }
  }, [ selectedTeamId, userTeams ]);

  const handleBlur = () => {
    const value = searchFieldRef.current.value;

    if (value === '') {
      searchParams.delete('search');
      searchParams.set('page', 1);
      setSearchParams(searchParams);
      getModels();
      return;
    }

    setSearchParams({ ...params, search: value, page: 1 });
    getModels();
  };

  const buildTeamOptions = () => {
      return userTeams.map(team => {
          return (
            <FovOption key={team.teamId} value={team.teamId}>
                {team.teamName}
            </FovOption>
          );
      });
  };

  const handleRequestCustomModelsClick = () => {
    window.open(
      'https://docs.google.com/forms/d/e/1FAIpQLSclF6D4vXI4Ku1tWC4UdKiYb3NaOBF_svt17C8zvwDRjKypjg/viewform',
      '_blank',
      'noopener,noreferrer',
    );
  };

  return (
    <HeaderArea>
      <VerticalSpacer size={8} />

      <Title>
        <H3>
          {pageTitle}
        </H3>

        {(
          <>
            <HorizontalSpacer size={8} />

            {modelsLoading &&
              <RefreshFiles>
                <RefreshOutlined spinIcon={modelsLoading} />
              </RefreshFiles>
            }
          </>
        )}

        <CreatorList theme={theme} $selectedTheme={selectedTheme}>
          {/*onCreators && '/ '}{typeof partners === 'string'
            ? [ partners ]?.sort().join(' / ')
            : partners?.sort().join(' / ')
          */}
        </CreatorList>

        {onTeamModels && userTeams.length > 0 &&
            <TeamListContainer>
                <FovSelect
                    value={selectedTeamId}
                    placeholder={'Select a team'}
                    onChange={(e, newVal) => {
                      if (selectedTeamId !== newVal) {
                        if (searchParams.has('selectedTeam')) searchParams.delete('selectedTeam');
                        dispatch(setSelectedUserTeam(newVal));
                        setSearchParams(searchParams);
                        getModels(newVal);
                        getTeamData(newVal);
                      }
                    }}
                >
                    {buildTeamOptions()}
                </FovSelect>
            </TeamListContainer>
        }
      </Title>


      <ActionArea>
        <CTA
          theme={theme}
          $selectedTheme={selectedTheme}
          onClick={handleRequestCustomModelsClick}
        >
          Request custom models
        </CTA>
      </ActionArea>

      <Search>
        <SearchInputField
          width={530}
          disabled={false}
          ref={searchFieldRef}
          defaultValue={searchFieldRef.current.value || decode(params.search)}
          onChange={e => searchFieldRef.current.value = e.target.value}
          onKeyUp={e => e.key === 'Enter' && e.target.blur()}
          onBlur={handleBlur}
        />
      </Search>

      <ViewOptions />

      <FovModal
        title='Request custom models'
        visible={showModal}
        maxWidth={2000}
        width={800}
        onClose={() => setShowModal(false)}
      >
        <HubSpotForm
          region='na1'
          portalId='7125801'
          formId='166318d8-be75-444d-b44f-d3092c9c1cad'
          targetId='modelRequestForm'
        />
      </FovModal>
    </HeaderArea>
  );
});

export { ModelsHeader };
